module.exports = __webpack_public_path__ + "static/media/profile_pic.f9da7b8b.jpg";